import { reduceAction } from '@elab/core/store/helpers';

import types from './types';

const initialState = {
    expandedStockInfoCardId: null,
    productRTS: {},
    cartRTS: {},
    lastStoreData: null,
    lastStoreIsUsed: false,
    toggledStockInfoList: false,
    storeName: '',
    inStockInLastStore: false,
    inputValue: '',
    rtsErrorMessage: '',
    deliveryInformation: {},
};

export default (state = initialState, { type, payload }) => {
    switch (type) {
        case types.TOGGLE_EXPANDED_STOCK_INFO:
            return toggleExpandedStockInfo(state, payload);

        case types.INITIALIZE:
            return initialState;

        case types.PRODUCT_STOCK_REQUEST:
            return {
                ...state,
                stores: [],
                isLoading: true,
            };

        case types.PRODUCTS_STOCK_REQUEST:
            return { ...state, isLoading: true, inputValue: payload.query || '' };

        case types.PRODUCT_STOCK_RESPONSE_SUCCESS:
            return {
                ...state,
                productRTS: { ...payload },
                isLoading: false,
                isError: false,
            };

        case types.PRODUCTS_STOCK_RESPONSE_SUCCESS:
            return {
                ...state,
                cartRTS: { stores: payload.stores },
                isLoading: false,
                isError: false,
            };

        case types.PRODUCT_STOCK_RESPONSE_FAILURE:
            return {
                ...state,
                isError: true,
                isLoading: false,
                storeErrorType: payload ? payload.errorType : '',
            };

        case types.TOGGLE_STOCK_INFO_LIST:
            return {
                ...state,
                toggledStockInfoList: !state.toggledStockInfoList,
            };

        case types.SET_STORES:
            return reduceAction(state, 'stores', payload);

        case types.CLEAR_STORES:
            return {
                ...state,
                productRTS: {
                    ...state.productRTS,
                    stores: [],
                },
                cartRTS: {
                    ...state.cartRTS,
                    stores: [],
                },
                errorMessage: '',
            };

        case types.CLEAR_ERROR:
            return reduceAction(state, 'storeErrorType', '');

        case types.SET_LAST_STORE_DATA:
            return reduceAction(state, 'lastStoreData', payload);

        case types.SET_LAST_STORE_IS_USED:
            return reduceAction(state, 'lastStoreIsUsed', payload);

        case types.QUANTITY_CHANGED:
            return reduceAction(state, 'quantity', payload.quantity);

        case types.RESET_RTS_ERRORS:
            return { ...state, isError: false, isLoading: false, storeErrorType: '' };

        case types.SAVE_STORE_NAME:
            return reduceAction(state, 'storeName', payload.storeId);

        case types.SET_IN_STOCK_IN_LAST_STORE:
            return reduceAction(state, 'inStockInLastStore', payload);
        case types.SET_RTS_ERROR_MESSAGE:
            return {
                ...state,
                rtsErrorMessage: payload.errorMessage,
            };
        case types.DELIVERY_INFORMATION:
            return {
                ...state,
                deliveryInformation: payload,
            };
        default:
            return state;
    }
};

function toggleExpandedStockInfo(state, { storeId }) {
    const newExpandedId = state.expandedStockInfoCardId === storeId ? null : storeId;

    return {
        ...state,
        expandedStockInfoCardId: newExpandedId,
        toggledStockInfoList: false,
    };
}
